import { render, staticRenderFns } from "./ViewAttributeGroupComponent.vue?vue&type=template&id=2242a3f0&scoped=true"
import script from "./ViewAttributeGroupComponent.vue?vue&type=script&lang=js"
export * from "./ViewAttributeGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242a3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2242a3f0')) {
      api.createRecord('2242a3f0', component.options)
    } else {
      api.reload('2242a3f0', component.options)
    }
    module.hot.accept("./ViewAttributeGroupComponent.vue?vue&type=template&id=2242a3f0&scoped=true", function () {
      api.rerender('2242a3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/ViewAttributeGroupComponent.vue"
export default component.exports